@if (iaChatbotUrl) {
  <app-ia-chat-web [iaChatbotUrl]="iaChatbotUrl"></app-ia-chat-web>
}
<router-outlet></router-outlet>
